import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import {
  NotificationMessage,
  NotificationPreference,
  PageResponse,
  UpdateNotificationPreferencePayload,
} from '../models';

/** Centre de notifications personnel (badge header + centre de notifications), porté par notification-service. */
@Injectable({ providedIn: 'root' })
export class NotificationService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiUrl}/notification-service/api/v1/notifications/me`;

  list(page = 0, size = 10): Observable<PageResponse<NotificationMessage>> {
    const params = new HttpParams().set('page', page).set('size', size);
    return this.http.get<PageResponse<NotificationMessage>>(this.baseUrl, { params });
  }

  unreadCount(): Observable<{ unreadCount: number }> {
    return this.http.get<{ unreadCount: number }>(`${this.baseUrl}/unread-count`);
  }

  markAllAsRead(): Observable<{ message: string }> {
    return this.http.patch<{ message: string }>(`${this.baseUrl}/read-all`, {});
  }

  markAsRead(notificationId: string): Observable<NotificationMessage> {
    return this.http.patch<NotificationMessage>(`${this.baseUrl}/${notificationId}/read`, {});
  }

  archive(notificationId: string): Observable<NotificationMessage> {
    return this.http.patch<NotificationMessage>(`${this.baseUrl}/${notificationId}/archive`, {});
  }

  remove(notificationId: string): Observable<{ message: string }> {
    return this.http.delete<{ message: string }>(`${this.baseUrl}/${notificationId}`);
  }

  preferences(): Observable<NotificationPreference> {
    return this.http.get<NotificationPreference>(`${this.baseUrl}/preferences`);
  }

  updatePreferences(payload: UpdateNotificationPreferencePayload): Observable<NotificationPreference> {
    return this.http.put<NotificationPreference>(`${this.baseUrl}/preferences`, payload);
  }
}
